import React, { useState, useEffect, } from "react";
import { Modal, Button,  } from 'antd';
import notification from '../../../services/notification';
import { FormattedMessage, useIntl, } from "react-intl";
import { useNavigate, useLocation, } from 'react-router';
import { useForm, } from "react-hook-form";
import { CustomerUpdate, } from '../../../services/customer';
import { GetCustomerUsergroups, } from '../../../services/users';
import { X, Pen, CheckSquare, CaretUp, } from "@phosphor-icons/react";
import CustomerFormView from './views/customer.form.view';

const CustomerEditModal = ({
    modalIsOpen,
    modalIsOpenHandler,
    customerData,
    refreshData,
    customFields,
    resetCustomerFieldsData,
    ...props
}) => {

    const [buttonDisabled, setButtonDisabled] = useState(false);
    const [hideProfileFields, setHideProfileFields] = useState(true);
    const [userGroups, setUserGroups] = useState(undefined);
    const { handleSubmit, reset, control, formState, watch, } = useForm({ mode: 'onChange' });
    const intl = useIntl();
    const history = useNavigate();
    const { pathname } = useLocation();
    const customerType = watch("customer_type");

    useEffect(() => {
        getUsergroups();
        // eslint-disable-next-line
    }, []);

    useEffect(() => {
        // setup correct data object
        const formdata = {
            "customer_name": customerData.customer_name,
            "customer_vat_number": customerData.customer_data?.customer_vat_number,
            "customer_registration_number": customerData.customer_data?.customer_registration_number,
            "customer_phone_number": customerData.customer_data?.customer_contact_data?.customer_phone_number,
            "customer_email": customerData.customer_data?.customer_contact_data?.customer_email,
            "customer_preference_language": customerData.customer_data?.customer_contact_data?.customer_preference_language,
            "customer_note": customerData.customer_note,
            "city": customerData?.customer_data?.customer_address?.city,
            "country": customerData?.customer_data?.customer_address?.country || 'nl',
            "street_number": customerData?.customer_data?.customer_address?.street_number,
            "zip_code": customerData?.customer_data?.customer_address?.zip_code,
            "customer_type": customerData?.customer_type,
            "customer_vat_shifted": customerData?.customer_data?.customer_vat_shifted,
            "customer_po_number": customerData?.customer_po_number,
            "customer_firstname": customerData?.customer_data?.customer_contact_data?.customer_firstname,
            "customer_lastname": customerData?.customer_data?.customer_contact_data?.customer_lastname,
            "user_group_ids": customerData?.user_group_ids,

            // Billing address info
            "customer_billing_enable": customerData?.customer_data?.customer_billing_enable,
            "customer_billing_name": customerData?.customer_data?.customer_billing_data?.customer_billing_name,
            "billing_city": customerData?.customer_data?.customer_billing_data?.customer_billing_address?.city,
            "billing_country": customerData?.customer_data?.customer_billing_data?.customer_billing_address?.country || 'nl',
            "billing_street_number": customerData?.customer_data?.customer_billing_data?.customer_billing_address?.street_number,
            "billing_zip_code": customerData?.customer_data?.customer_billing_data?.customer_billing_address?.zip_code,
            "customer_billing_email": customerData?.customer_data?.customer_billing_data?.customer_billing_email,

            customfields: resetCustomerFieldsData,
        };
        reset(formdata);

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [resetCustomerFieldsData])

    useEffect(() => {
        if (pathname === '/profile/detail') {
            setHideProfileFields(true);
        } else {
            setHideProfileFields(false);
        }

        return () => {
            // cleanup
        }
        // below line needed to remove the warning on build.
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [customerData, pathname])

    const onSubmit = (data) => {
        setButtonDisabled(true);

        const postdata = {
            customer_type: customerType,
            customer_id: customerData.customer_id,
            ...data
        };
        postdata.customer_name = (customerType === "COMPANY" || customerType === "DEALER") ? data.customer_name : `${data.customer_firstname} ${data.customer_lastname}`;

        CustomerUpdate(postdata, history)
            .then(response => {
                if (response.status) {
                    notification['success']({
                        message: 'Update',
                        description: intl.formatMessage({ id: response.msg }),
                    });

                    //close modal
                    refreshData();
                    modalIsOpenHandler(false);
                } else {
                    notification['error']({
                        message: 'Update',
                        description: intl.formatMessage({ id: response.msg }),
                    });
                    setButtonDisabled(false);
                }
            })
            .catch(error => {

                notification['error']({
                    message: 'Account',
                    description: intl.formatMessage({ id: "UNKNOW_ERROR" }),
                });
                setButtonDisabled(false);
            });
    };

    const FormError = () => {
        return (<>
            <CaretUp size={18} /> <span>Form contains error's</span>
        </>)
    };

    const getUsergroups = () => {
        GetCustomerUsergroups(customerData.customer_id, history)
            .then(response => {
                if (response.status) {
                    var tmp = [];
                    for (let i = 0; i < response.data.user_groups.length; i++) {
                        tmp.push({
                            value: response.data.user_groups[i].ug_id,
                            label: response.data.user_groups[i].ug_name
                        });
                    }

                    setUserGroups(tmp);
                }
            })
            .catch(error => { });
    };

    return (

        <Modal
            open={modalIsOpen}
            title={<><Pen size={18} /> <FormattedMessage id="customer-edit-details" /></>}
            onCancel={() => modalIsOpenHandler(false)}
            width={750}
            footer={[
                <span key="0" className="mr-4" style={{ fontWeight: "700", color: "red" }}>{!formState.isValid && <FormError />}</span>,
                <Button key="1" onClick={() => modalIsOpenHandler(false)}
                    icon={<X size={16} />}>
                    <FormattedMessage id="cancel" />
                </Button>,
                <Button key="2"
                    className="ant-btn-success"
                    loading={buttonDisabled}
                    onClick={handleSubmit(onSubmit)}
                    icon={!buttonDisabled && (<CheckSquare size={16} />)}>
                    <FormattedMessage id="save" />
                </Button>,
            ]}>

            <CustomerFormView
                history={history}
                control={control}
                watch={watch}
                editMode="edit"
                hideProfileFields={hideProfileFields}
                userGroups={userGroups}
                {...props}
            />

        </Modal>
    );
};

export default CustomerEditModal;